import { contentOf, forkDocument } from '@orbit-mind/domain';
import { appError, err, ok, } from '@orbit-mind/shared-types';
import { parseDocument } from '@orbit-mind/validators';
/** A standalone JSON has no file bytes. Validate and preview before writing an independent copy. */
export function previewNativeDocument(text, target) {
    if (new TextEncoder().encode(text).byteLength > 10 * 1024 * 1024)
        return err(appError('VALIDATION_FAILED', 'Limite do arquivo Orbit Mind: 10 MB.'));
    try {
        const parsed = parseDocument(JSON.parse(text), 'storage', 'Orbit Mind JSON');
        if (!parsed.ok)
            return err(appError('VALIDATION_FAILED', 'O arquivo não é um mapa Orbit Mind válido.'));
        const copy = forkDocument(parsed.value, target.mapId, parsed.value.map.title, target.now).document;
        let removedFiles = 0;
        let removedMedia = 0;
        const nodes = Object.fromEntries(Object.entries(copy.nodes).map(([id, node]) => {
            removedFiles += node.attachments?.length ?? 0;
            const content = contentOf(node);
            const missing = content !== undefined && 'attachmentId' in content;
            if (missing)
                removedMedia++;
            const metadata = { ...node.metadata };
            if (missing)
                delete metadata.content;
            return [id, { ...node, attachments: [], metadata }];
        }));
        return ok({
            document: {
                ...copy,
                nodes,
                map: { ...copy.map, ownerId: target.ownerId, workspaceId: target.workspaceId },
            },
            removedFiles,
            removedMedia,
        });
    }
    catch {
        return err(appError('VALIDATION_FAILED', 'Não foi possível ler o arquivo Orbit Mind.'));
    }
}
export function importNativeDocument(text, target) {
    const preview = previewNativeDocument(text, target);
    return preview.ok ? ok(preview.value.document) : preview;
}
//# sourceMappingURL=native-document.js.map